import { Controller } from "@hotwired/stimulus"
import { slideDown, slideUp } from "../src/slide"

// Connects to data-controller="job-form-step2"
export default class extends Controller {
  static targets = ["smokingCountermeasuresNotes", "insuranceNotes"];
  declare readonly smokingCountermeasuresNotesTarget: HTMLElement; // 受動喫煙防止措置の詳細
  declare readonly insuranceNotesTarget: HTMLElement; // 社会保険の詳細

  connect(): void {
    this.initScroll();
  }

  initScroll(): void {
    const errorElement = document.querySelector('.txt_error');
    if (errorElement) {
      const elementRect = errorElement.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / 2);
      window.scrollTo({ top: middle, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }

  // 社会保険の詳細の表示切り替え
  updateInsurance({ params }) {
    const isInsurance = params.isInsurance;
    if (isInsurance) {
      slideDown(this.insuranceNotesTarget);
    } else {
      slideUp(this.insuranceNotesTarget);
    }
  }

  // 受動喫煙防止措置の詳細の表示切り替え
  updateSmokingCountermeasures({ params }) {
    const isSmoking = params.isSmoking;
    if (isSmoking) {
      slideDown(this.smokingCountermeasuresNotesTarget);
    } else {
      slideUp(this.smokingCountermeasuresNotesTarget);
    }
  }

  // 福利厚生・追加ボタンクリック時の処理
  addBenefit(): void {
    const input = document.createElement('div');
    input.className = 'input_benefit_block';
    input.innerHTML = `
      <input type="text" name="benefit[custom_benefit_names][]" maxlength="255" placeholder="待遇・福利厚生を入力してください">
      <i class="fa-solid fa-circle-xmark btn_delete_inputBenefitBlock" data-action="click->job-form-step2#deleteInputBenefit"></i>
    `;

    const inputBenefitArea = document.querySelector('.input_benefit_area');
    if (inputBenefitArea) {
      inputBenefitArea.appendChild(input);
    }
  }

  // 福利厚生・削除ボタンクリック時の処理
  deleteInputBenefit(event: Event): void {
    const button = event.currentTarget as HTMLElement;
    const inputBlock = button.closest('.input_benefit_block');
    if (inputBlock) {
      inputBlock.remove();
    }
  }
}
